/**
 * Permission codes — GENERATED FILE, DO NOT EDIT.
 *
 * Mirrors sdk/onecall_shared/auth/permissions.py, the single source of truth the
 * API gateway and every service enforce. Hand-copied codes are what produced
 * VAPT-2026-001: a gate that never fires (typo) or fires on the wrong action
 * shows a control the API refuses.
 *
 * Regenerate:  python tools/gen_frontend_permissions.py
 * Guarded by:  src/constants/permissions.drift.test.js (support_frontend)
 */

export const StandardPermission = Object.freeze({
    Agents: Object.freeze({
        READ: 'agents:read',
        CREATE: 'agents:create',
        UPDATE: 'agents:update',
        DELETE: 'agents:delete',
        EXPORT: 'agents:export',
        IMPORT: 'agents:import',
    }),
    Tickets: Object.freeze({
        READ: 'tickets:read',
        CREATE: 'tickets:create',
        UPDATE: 'tickets:update',
        DELETE: 'tickets:delete',
    }),
    CallHistory: Object.freeze({
        READ: 'call_history:read',
        CREATE: 'call_history:create',
        EXPORT: 'call_history:export',
        UPDATE: 'call_history:update',
        DELETE: 'call_history:delete',
    }),
    Calls: Object.freeze({
        INITIATE: 'calls:initiate',
    }),
    Users: Object.freeze({
        READ: 'users:read',
        INVITE: 'users:invite',
        UPDATE: 'users:update',
        DELETE: 'users:delete',
        MANAGE_ROLES: 'users:manage_roles',
    }),
    Organization: Object.freeze({
        READ: 'organization:read',
        UPDATE: 'organization:update',
    }),
    Billing: Object.freeze({
        READ: 'billing:read',
        MANAGE: 'billing:manage',
    }),
    Campaigns: Object.freeze({
        READ: 'campaigns:read',
        CREATE: 'campaigns:create',
        UPDATE: 'campaigns:update',
        DELETE: 'campaigns:delete',
    }),
    Contacts: Object.freeze({
        READ: 'contacts:read',
        CREATE: 'contacts:create',
        UPDATE: 'contacts:update',
        DELETE: 'contacts:delete',
    }),
    Qr: Object.freeze({
        READ: 'qr:read',
        CREATE: 'qr:create',
        UPDATE: 'qr:update',
        DELETE: 'qr:delete',
    }),
    Knowledge: Object.freeze({
        READ: 'knowledge:read',
        CREATE: 'knowledge:create',
        UPDATE: 'knowledge:update',
        DELETE: 'knowledge:delete',
    }),
    Integrations: Object.freeze({
        READ: 'integrations:read',
        MANAGE: 'integrations:manage',
    }),
    PhoneNumbers: Object.freeze({
        READ: 'phone_numbers:read',
        MANAGE: 'phone_numbers:manage',
    }),
    Reminders: Object.freeze({
        READ: 'reminders:read',
        CREATE: 'reminders:create',
        UPDATE: 'reminders:update',
        DELETE: 'reminders:delete',
    }),
    Smartflo: Object.freeze({
        READ: 'smartflo:read',
        MANAGE: 'smartflo:manage',
    }),
    CsvQuery: Object.freeze({
        EXECUTE: 'csv_query:execute',
    }),
    Memory: Object.freeze({
        READ: 'memory:read',
        CREATE: 'memory:create',
        UPDATE: 'memory:update',
        DELETE: 'memory:delete',
        SESSION: 'memory:session',
    }),
    ApiKeys: Object.freeze({
        READ: 'api_keys:read',
        MANAGE: 'api_keys:manage',
    }),
    Roles: Object.freeze({
        READ: 'roles:read',
        CREATE: 'roles:create',
        UPDATE: 'roles:update',
        DELETE: 'roles:delete',
    }),
    Analytics: Object.freeze({
        READ: 'analytics:read',
        SENTIMENT: 'analytics:sentiment',
        ESCALATIONS: 'analytics:escalations',
        ROUTING: 'analytics:routing',
        EXECUTIVE: 'analytics:executive',
        TEAM: 'analytics:team',
        ACCOUNTS: 'analytics:accounts',
        AGENT: 'analytics:agent',
        COACHING: 'analytics:coaching',
        REPORTS: 'analytics:reports',
        CONNECTORS: 'analytics:connectors',
        WEBHOOKS: 'analytics:webhooks',
        EXPORTS: 'analytics:exports',
        SETTINGS: 'analytics:settings',
    }),
    Platform: Object.freeze({
        CONFIG: 'platform:config',
        MONITORING: 'platform:monitoring',
        LANGUAGES: 'platform:languages',
        PHONE_POOL: 'platform:phone_pool',
        DASHBOARD: 'platform:dashboard',
        KNOWLEDGE: 'platform:knowledge',
    }),
});

/** Every code in the registry — used by the drift guard. */
export const ALL_CODES = Object.freeze([
    'agents:create',
    'agents:delete',
    'agents:export',
    'agents:import',
    'agents:read',
    'agents:update',
    'analytics:accounts',
    'analytics:agent',
    'analytics:coaching',
    'analytics:connectors',
    'analytics:escalations',
    'analytics:executive',
    'analytics:exports',
    'analytics:read',
    'analytics:reports',
    'analytics:routing',
    'analytics:sentiment',
    'analytics:settings',
    'analytics:team',
    'analytics:webhooks',
    'api_keys:manage',
    'api_keys:read',
    'billing:manage',
    'billing:read',
    'call_history:create',
    'call_history:delete',
    'call_history:export',
    'call_history:read',
    'call_history:update',
    'calls:initiate',
    'campaigns:create',
    'campaigns:delete',
    'campaigns:read',
    'campaigns:update',
    'contacts:create',
    'contacts:delete',
    'contacts:read',
    'contacts:update',
    'csv_query:execute',
    'integrations:manage',
    'integrations:read',
    'knowledge:create',
    'knowledge:delete',
    'knowledge:read',
    'knowledge:update',
    'memory:create',
    'memory:delete',
    'memory:read',
    'memory:session',
    'memory:update',
    'organization:read',
    'organization:update',
    'phone_numbers:manage',
    'phone_numbers:read',
    'platform:config',
    'platform:dashboard',
    'platform:knowledge',
    'platform:languages',
    'platform:monitoring',
    'platform:phone_pool',
    'qr:create',
    'qr:delete',
    'qr:read',
    'qr:update',
    'reminders:create',
    'reminders:delete',
    'reminders:read',
    'reminders:update',
    'roles:create',
    'roles:delete',
    'roles:read',
    'roles:update',
    'smartflo:manage',
    'smartflo:read',
    'tickets:create',
    'tickets:delete',
    'tickets:read',
    'tickets:update',
    'users:delete',
    'users:invite',
    'users:manage_roles',
    'users:read',
    'users:update',
]);
